// Release notes / changelog — newest first. Keep entries short and user-facing.
export const UPDATES = [
  {
    date: "2026-08-12",
    version: "It Is Established Premium",
    items: [
      "Introducing Premium — $4.99/month or $49.99/year (2 months free), with a 7-day free trial.",
      "Premium unlocks unlimited decrees and 'load more', full 3–40 day Decree Plans with multiple running at once, the complete teaching library, unlimited Lexicon word studies, all 4 highlight colors, and unlimited searchable history.",
      "Free accounts keep full decree sets, listening, all 9 Bible translations, 3-day plans, and Newsfeed access.",
      "Manage your subscription anytime from your profile — upgrade, cancel, or restore purchases.",
    ],
  },
  {
    date: "2026-07-16",
    version: "Community Newsfeed & Sharing",
    items: [
      "New Newsfeed — now your home when you sign in. See public decrees and prayer requests from believers across the app.",
      "React to any post: tap “Amen” on a decree or “I'm praying” on a prayer request.",
      "Share decrees straight to X, Facebook, WhatsApp, or anywhere via your phone's share sheet — each link opens a beautiful page that leads friends right back to the app.",
      "Post a decree publicly to the Newsfeed (with your name or anonymously), or keep it private.",
      "Focus a decree on a single word from a verse, and turn any decree set into a multi-day Decree Plan in one tap.",
    ],
  },
  {
    date: "2026-07-12",
    version: "Prayer Requests & Sharper Decrees",
    items: [
      "New: submit a Prayer Request — with your name or anonymously — sent privately to the prayer team.",
      "Decrees now speak scripture references right inside the declaration, in varied natural ways.",
      "Decrees are now spoken in present or completed tense — never 'someday', always established now.",
    ],
  },
  {
    date: "2026-07-05",
    version: "Highlights, Resume & New Teaching",
    items: [
      "Highlight verses in the Bible reader (4 colors) — your highlights save to your account and sync across devices.",
      "The Bible reader now remembers where you left off and reopens to that passage.",
      "New teaching course: ICU Level 2 — an apostolic manual for building effectual prayer teams (8 lessons).",
      "Teachings is now organized into multiple courses with per-course progress.",
    ],
  },
  {
    date: "2026-07-04",
    version: "Concordance & Decree Plans",
    items: [
      "Lexicon now shows every KJV verse a Hebrew/Greek word appears in — read the full verse inline or jump straight into the Bible.",
      "New Decree Plans (3–40 days) — pick a single theme or a guided journey, choose how many decrees per day, and build a daily streak.",
      "Each plan day unlocks one at a time with progress tracking, so consistency becomes a habit.",
    ],
  },
  {
    date: "2026-07-02",
    version: "Bible & Word Study",
    items: [
      "New Bible tab — read the Word in 9 translations (KJV, WEB, ASV, BSB, YLT, Darby, BBE, Webster, Douay-Rheims), open to everyone.",
      "Search any verse (“John 3:16”), a passage range (“Psalm 23:1-6”), or a phrase, and filter by testament, book and chapter.",
      "“Decree this verse” — turn any verse straight into a set of personalized, scripture-rooted decrees.",
      "Every decree set and the Daily Decree now open with the Hebrew/Greek meaning (Strong’s) of your key words.",
      "Admin dashboard now shows usage: accounts, decrees generated, and guest activity.",
    ],
  },
  {
    date: "2026-06-30",
    version: "Launch",
    items: [
      "Generate 10–15 powerful first-person decrees from any topic, for yourself, another person, or a group.",
      "Daily Decree, Kingdom 101 teachings, and a Strong’s Concordance Lexicon with AI word studies.",
      "Listen to your decrees aloud, copy and share them, and save your history.",
      "Community — connect with friends and share your journey.",
      "Sign in with email or Google, and pull down to refresh anywhere.",
    ],
  },
];
